import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { App } from '@df/core/app';
import { SAMPLES_CONFIG } from '@df/samples/config/samples.config';
import { NSamples } from '@df/samples/samples.namespace';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { Samples } from './samples';
@NgModule()
export class LocalSamplesModule {
    static forRoot(config?: DeepPartial<NSamples.IConfig>): ModuleWithProviders<LocalSamplesModule> {
        return {
            ngModule: LocalSamplesModule,
            providers: [
                Samples,
                {
                    provide: APP_INITIALIZER,
                    useFactory: (samples: Samples) => () => { },
                    deps: [Samples],
                    multi: true
                },
                {
                    provide: SAMPLES_CONFIG,
                    useFactory: (app: App) => {
                        const defaultConfig: DeepPartial<NSamples.IConfig> = {
                            ...NSamples.DEFAULT_CONFIG
                        };
                        return defaultsDeep(config || {}, defaultConfig);
                    },
                    deps: [App]
                }
            ]
        };
    }
}
